export default __webpack_public_path__ + "media/images/portfolio/gallery-07-370x470-c0fb76f37de721f1785be9d3a03d9c97.jpg";